import { Link } from 'react-router-dom';

import { Icon, Text } from '../../common/components';
import { t } from '../../common/i18n';
import { offerIcon } from '../config/catalogConfig';
import { partnerDetailPath } from '../hooks/usePreviewToken';
import { ServicePartner } from '../types';
import PartnerLogo from './PartnerLogo';

const namespace = 'OtherServices';

interface PartnerCardProps {
  partner: ServicePartner;
  preview?: string | null;
}

/**
 * Karta prověřeného partnera v gridu – celá je odkaz do detailu. Nahoře tmavý pruh (přechod
 * značky) s logem v bílé variantě (CSS filtr, funguje na jakékoli logo bez podkladu), takže
 * různobarevné brandy vedle sebe nedělají „cirkus"; pod ním název, co partner dělá a výčet služeb,
 * v patičce „Zjistit víc" na stejném místě jako u ostatních dlaždic.
 */
export const PartnerCard: React.FC<PartnerCardProps> = ({ partner, preview = null }) => (
  <Link to={partnerDetailPath(partner.slug, preview)} className="PartnerCard">
    <div className="PartnerCard__band">
      <PartnerLogo partner={partner} size="small" className="PartnerCard__logo" />
    </div>

    <div className="PartnerCard__body">
      <Text as="h3" size="h3" color="Neutral800" className="PartnerCard__name">
        {partner.name}
      </Text>
      <Text as="p" size="body-small" color="Neutral700" className="PartnerCard__claim">
        {partner.claim}
      </Text>

      <ul className="PartnerCard__offers">
        {partner.offers.map((offer) => (
          <li key={offer.slug}>
            <Icon name={offerIcon(offer)} />
            <span>{offer.title}</span>
          </li>
        ))}
      </ul>

      <div className="PartnerCard__footer">
        <span className="PartnerCard__cta">
          {t('Card.more', namespace)}
          <Icon name="arrowRightSmall" />
        </span>
      </div>
    </div>
  </Link>
);

export default PartnerCard;
